import React__default from 'react';
import styled from 'styled-components';
import { CSSGenerateFlexAlign, CSSGenerateFlexJustify } from '../styles/cssGenerate.js';
import { getResponsiveProps } from '../styles/useResponsiveProps.js';
import { Hidden } from './Hidden.js';

const InlineWrapper = styled.div`
  display: flex;
  flex-direction: row;
  ${(props)=>props.height === "fill" && "height: 100%;"}
  ${(props)=>props.width === "fill" && "width: 100%;"}
  ${(props)=>props.alignY !== undefined ? getResponsiveProps(props.alignY)(CSSGenerateFlexAlign) : ""}
  ${(props)=>props.align !== undefined ? getResponsiveProps(props.align)(CSSGenerateFlexJustify) : ""}
  text-align: ${(props)=>props.align !== undefined ? getResponsiveProps(props.align)((align)=>align) : ""};
`;
const InlineInnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: ${(props)=>props.$wrap ? "wrap" : "nowrap"};
  margin-left: -${(props)=>props.gap}rem;
  margin-top: -${(props)=>props.gap}rem;
  ${(props)=>props.width === "fill" && `width: calc(100% + ${props.gap}rem);`}
  ${(props)=>props.alignY !== undefined ? getResponsiveProps(props.alignY)(CSSGenerateFlexAlign) : ""}
  ${(props)=>props.align !== undefined ? getResponsiveProps(props.align)(CSSGenerateFlexJustify) : ""}
  text-align: ${(props)=>props.align !== undefined ? getResponsiveProps(props.align)((align)=>align) : ""};

  /* Use double & to 'double up' the class that is generated i.e. .stack-class.stack-class  */
  /* this overrides simple selectors in specificity - e.g. .heading-class - no matter their order in the css. */
  && > * {
    margin-left: ${(props)=>props.gap}rem;
    margin-top: ${(props)=>props.gap}rem;
  }

  /* Hidden elements should not count towards spacing calculations */
  && > [${Hidden.dataId}-is-hidden] {
    margin-left: 0;
    margin-top: 0;
  }
`;
/**
 * Layout component for creating inline layouts (e.g. tags, heading and text .etc). Makes other
 * componentry more composable by removing layout alignment and spread from other components.
 *
 * Can also be used as a containing element
 *
 * @example
 * <Inline align="center" alignY="center">
 *  <Button />
 *  <Heading />
 * </Inline>
 */ const Inline = ({ gap =0 , wrap =true , children , ...props })=>{
    return React__default.createElement(InlineWrapper, {
        "data-hpy-web-inline": true,
        ...props
    }, React__default.createElement(InlineInnerWrapper, {
        "data-hpy-web-inline-inner": true,
        ...props,
        gap: gap,
        "$wrap": wrap
    }, children));
};
Inline.dataId = "data-hpy-web-inline";
Inline.displayName = "Inline";

export { Inline };
